var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandVivaldiStyleBlack = function SvgBrandVivaldiStyleBlack(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#svg_icon_BrandVivaldiStyleBlack__clip0_3953_125074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.332 17.507q2.218-3.86 4.436-7.712c.18-.311.253-.643.2-.997-.105-.823-.947-1.419-1.757-1.24-.995.222-1.485 1.25-1.027 2.169.169.332.248.69.253 1.113l-.007.082-.014.16a2.39 2.39 0 0 1-2.516 2.12c-.868-.052-1.521-.469-1.963-1.213a49 49 0 0 1-.58-.997l-.315-.548q-.263-.455-.525-.911-.358-.623-.717-1.241c-.305-.522-.768-.802-1.368-.77-1.137.058-1.78 1.266-1.21 2.257q.516.906 1.037 1.807l1.086 1.89c.783 1.366 1.568 2.734 2.36 4.094.31.528.795.786 1.406.744.547-.042.947-.327 1.22-.807"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 23.963c-5.247 0-8.163 0-10.074-1.899C.021 20.16.021 17.248.021 12.005s0-8.155 1.905-10.059C3.836.042 6.753.042 12 .042s8.163 0 10.074 1.899C23.979 3.845 23.979 6.757 23.979 12s0 8.154-1.905 10.059c-1.91 1.904-4.827 1.904-10.074 1.904M5.62 5.676c3.505-3.503 9.184-3.503 12.684 0 3.506 3.497 3.506 9.172 0 12.675-3.505 3.502-9.184 3.502-12.684 0-3.5-3.497-3.5-9.173 0-12.675",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandVivaldiStyleBlack__clip0_3953_125074"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandVivaldiStyleBlack);
export { ForwardRef as ReactComponent };